export default __webpack_public_path__ + "static/media/linked.f83c1cd0.svg";